import React from "react";
import "./App.css";
import { Provider } from "react-redux";
import AppRouter from "./Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "./store/store";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <ToastContainer />
        <AppRouter />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
